import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { profile, projects } from '../../common/content';
import { analytics } from '../../utils/analytics';

export const ProjectScreen = () => (
  <>
    <header className="container page-intro">
      <p className="eyebrow">Selección de trabajo</p>
      <h1>Proyectos y decisiones.</h1>
      <p>Una muestra de mi trabajo en modernización, desarrollo e integración. En cada caso distingo el contexto, mi aportación y lo que puede mostrarse públicamente.</p>
    </header>
    <section className="container case-list" aria-label="Casos seleccionados">
      {projects.map(project => {
        const linkTarget = project.url || (project.image && project.image.replace('.webp', '.gif'));
        return (
        <article id={project.id} key={project.id} className="project-case" onMouseEnter={() => analytics.trackProjectHover(project.name)}>
          <div className="project-case__intro">
            <p className="eyebrow">{project.category}</p>
            <h2>{project.name}</h2>
            <p className="project-role">Mi rol: {project.role}</p>
            <p>{project.description}</p>
          </div>
          <div>
            <details className="case-details">
              <summary>Mi aportación y decisiones <FontAwesomeIcon icon={faChevronDown} /></summary>
              <h3>Aportación</h3><p>{project.contribution}</p>
              <h3>Criterio técnico</h3><p>{project.decision}</p>
              <h3>Tecnologías</h3><p>{project.technologies}</p>
            </details>
            <small>{project.evidence}</small>
            {linkTarget && <a className="text-link" href={linkTarget} target="_blank" rel="noopener noreferrer" onClick={() => analytics.trackExternalLink(project.name, linkTarget)}>{project.linkLabel || (project.url ? 'Visitar tienda' : 'Ver captura animada')} <FontAwesomeIcon icon={faArrowRight} /></a>}
          </div>
        </article>
      );
      })}
    </section>
    <section id="axiomflow" className="axiom-projects">
      <div className="container">
        <div className="section-heading">
          <div><p className="eyebrow">Iniciativa propia</p><h2>Productos de AxiomFlow.</h2></div>
          <p>Soluciones que desarrollo desde necesidades concretas. Su estado se presenta de forma explícita, sin confundir una prueba con un producto ya desplegado.</p>
        </div>
        <div className="own-project-grid">
          <article className="own-project">
            <span className="project-state">Caso: SUNSET Collection</span><h3>Tiendas autoadministrables</h3>
            <p>Una solución independiente por negocio. SUNSET es el caso concreto de una tienda con identidad propia; AxiomFlow es la marca desde la que ofrezco el desarrollo y la integración.</p>
            <Link className="text-link" to="/projects#sunset">Ver el caso SUNSET <FontAwesomeIcon icon={faArrowRight} /></Link>
          </article>
          <article className="own-project">
            <span className="project-state">Experiencia en consultorio</span><h3>Asistente odontológico</h3>
            <p>Un asistente probado para la atención de un consultorio odontológico. La siguiente demostración amplía el contexto administrativo a una clínica completa.</p>
            <Link className="text-link" to="/#contacto">Explorar una integración <FontAwesomeIcon icon={faArrowRight} /></Link>
          </article>
          <article className="own-project">
            <span className="project-state">Herramienta propia</span><h3>FutsalMetrics</h3>
            <p>Seguimiento del rendimiento por jugador, creado desde mi relación con el futsal. Una muestra de desarrollo de software para necesidades de un sector.</p>
            <Link className="text-link" to="/#contacto">Conversemos sobre tu sector <FontAwesomeIcon icon={faArrowRight} /></Link>
          </article>
        </div>
        {profile.axiomflowUrl && <a className="text-link" href={profile.axiomflowUrl} target="_blank" rel="noopener noreferrer">Visitar AxiomFlow <FontAwesomeIcon icon={faArrowRight} /></a>}
      </div>
    </section>
    <section className="container additional-projects" aria-labelledby="additional-title">
      <p className="eyebrow">Otras experiencias</p><h2 id="additional-title">Web y aplicaciones móviles.</h2>
      <div className="additional-grid">
        <article><h3>Quiz</h3><p>Frontend en Angular, trabajo de UX/UI con el equipo de diseño, coordinación con backend y pruebas de carga con JMeter.</p></article>
        <article><h3>Solicitud de cita</h3><p>Desarrollo full stack de una aplicación híbrida con Ionic y Cordova, conectada a una API REST en PHP.</p></article>
      </div>
    </section>
  </>
);